import _ from 'lodash';

export const isModified = (fields, initialContent) => {
  if (_.find(_.omit(fields, 'content'), field => field.dirty)) {
    return true;
  }
  return JSON.stringify(initialContent) !== JSON.stringify(fields.content.value);
};



// WEBPACK FOOTER //
// ./app/services/post-form-utils.js